
      window.__SUPABASE_AUTH_HOST__ = (import.meta.env.VITE_SUPABASE_AUTH_DOMAIN || 'auth.getvitly.com').replace(/^https?:\/\//, '').toLowerCase();
    